




















































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from "../../../../../../../../Mixins/ModelSetter";
import { SelectOption } from '../../../../../../../../logic/types'
import { PropertyFieldType } from '../../../../../../../BotProperties/components/Properties/types'
import {
  getPropertiesByType,
  prepareForFormulaInput,
  setPlaceholderPath
} from '../../../../../../../BotProperties/utils'
import ConfigField from "../../../../../../../ConfigField/ConfigField.vue";
import CreateIfEmpty from '../../../../../../../CreateIfEmpty.vue'
import { UseFields } from '../../../../../../../Pi'
import NestedContent from '../../../../../../../Pi/components/NestedContent.vue';
import { FieldData, SelectOptionData } from '../../../../../../../Pi/types'
import CashRegisterSetup from "../../../../../../../Shop/CashRegisters/CashRegisterSetup.vue";
import CreateNewProduct from '../../../../../../../Shop/Products/CreateNewProduct.vue'
import FormulaInput from '../../../../../../../f/FormulaInput.vue'
import InactiveInput from '../../../../../components/InactiveSidebarInput/InactiveInput.vue'
import { SendInvoiceNode } from '../logic/SendInvoiceNode'

type SendInvoiceCountType = SendInvoiceNode['data']['count']['type']

@Component({
  components: {
    CashRegisterSetup,
    ConfigField,
    CreateIfEmpty,
    FormulaInput,
    InactiveInput,
    CreateNewProduct,
    NestedContent
  }
})
export default class SendInvoiceNodeSidebar extends Mixins<UseFields, ModelSetter>(UseFields, ModelSetter) {
  @Prop() node!: SendInvoiceNode

  countType: SendInvoiceCountType = 'Constant'

  countTypes: Array<SelectOption> = [
    { label: this.$t('send_invoice_node_sidebar_count_type_option_constant').toString(), value: 'Constant' },
    { label: this.$t('send_invoice_node_sidebar_count_type_option_calculate').toString(), value: 'Calculate' },
  ]

  onCountTypeChange(option: SelectOption) {
    const value: SendInvoiceCountType = option.value

    this.node.setCountModel(value)
  }

  get inactiveTime(): number {
    return this.node.data.inactive_action.time
  }

  set inactiveTime(time: number) {
    this.node.setInactiveTime(time)

    if (time > 0) {
      this.$set(this.node.data, 'inactive_remove', false)
    } else {
      this.$delete(this.node.data, 'inactive_remove')
    }
  }

  get cashRegistersOptions(): Array<SelectOptionData> {
    return this.node.nodeProps.getCashRegisters()
      .map((c) => ({
        label: c.name,
        value: c.id,
        tags: !c.valid ? [ { text: this.$t('error').toString(), color: 'rgba(var(--a-danger), 1)' } ] : []
      }))
  }

  get productsOptions(): Array<SelectOptionData> {
    const cashRegister = this.selectedCashRegister

    if (cashRegister) {
      return this.node.nodeProps.getProducts()
        .filter(p => p.currency === cashRegister.currency)
        .map((p) => ({ label: p.name, value: p.id }))
    } else {
      return this.node.nodeProps.getProducts()
        .map((p) => ({ label: p.name, value: p.id }))
    }
  }

  newCashRegister = { isOpen: false, initName: '' }
  newProduct = { isOpen: false, initName: '' }

  activeCashRegisterId: number | null = null

  get context(): this {
    return this
  }

  get discountExist(): boolean {
    return !!this.node.data.discount
  }

  get discount(): string {
    if (this.node && this.node.data.discount) {
      return this.node.data.discount.value
    }
    return ''
  }

  set discount(val: string) {
    if (this.node.data.discount) {
      this.node.data.discount.value = val
    }
  }

  switchDiscount(arg: FieldData): FieldData {
    arg.setter = () => this.node.switchDiscount()
    return arg
  }

  constantCountSetter(args: FieldData): FieldData {
    args.setter = (value: number | string) => {
      args.model[args.key] = +value
    }

    return args
  }

  switchInactiveRemove(arg: FieldData): FieldData {
    arg.setter = (value) => this.node.setInactiveRemove(value)
    return arg
  }

  get formulaProperties(): Array<SelectOptionData> {
    const placeholdersWithPath = setPlaceholderPath(this.node.nodeProps.getProperties())
    const numProperties = getPropertiesByType(placeholdersWithPath, [ PropertyFieldType.Double, PropertyFieldType.Number ])

    return prepareForFormulaInput(this.$i18n, numProperties)
  }

  get selectedCashRegister() {
    return !!this.node.nodeProps.cashRegisterLogic
      && this.node.data.cash_register_id !== null
      && this.node.nodeProps.cashRegisterLogic.getCashRegister(this.node.data.cash_register_id)
  }

  handleCashRegisterOption(option?: Pick<SelectOption, 'label'>): void {
    this.newCashRegister.initName = option ? option.label : ''
    this.newCashRegister.isOpen = true
  }

  handleProductOption(option?: Pick<SelectOption, 'label'>): void {
    this.newProduct.initName = option ? option.label : ''
    this.newProduct.isOpen = true
  }

  setCashRegister(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setCashRegister(val)
    return arg
  }

  setProduct(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setProduct(val)
    return arg
  }

  mounted() {
    this.countType = this.node.data.count.type
  }
}
